import alt from 'components/Dispatcher';

/** These actions are triggered by <FileUploadSharingDialogForm /> */
class SharingFormActions {
  constructor() {
    this.generateActions(
      'reset',
      'updateComments',
      'updateContentToShare',
      'updateExpireAccess',
      'updatePassword',
      'updatePasswordProtection',
      'updateSelectedHighlights',
      'updateSharingTargets',
      'updateSharingValues',
      'updateHighlights',
      'updateUsersError',
      'updateUsersSuccess',
      'updateWillExpireAccess',
      'updateRequestFeedback'
    );
  }
}

export default alt.createActions(SharingFormActions);
